<template>
  <div v-if="isVisible || closing" class="popup-overlay" @click="closePopup">
    <div class="popup-area">
      <div :class="['popup-content', { 'slide-down': closing }]" @click.stop>
        <!-- Modal Header -->
        <div class="popup-header">
            <span class="close-btn">
                <button @click="closePopup">✕</button>
            </span>
          <span class="header-info">You are missing out on these perks!</span>
        </div>
        <div class="containerdashed alt"></div>
        <!-- <hr class="new2"> -->
        <!-- Perks Section -->
        <div class="popup-body">
          <div class="perk" v-for="(perk, index) in perks" :key="index">
            <img :src="perk.icon" :alt="perk.title" />
            <p>{{ perk.title }}</p>
          </div>
        </div>
        
        <!-- Membership Button -->
        <button class="membership-btn" @click="purchaseMembership">{{bannerPlaceHolderForMemberShipBanner &&  bannerPlaceHolderForMemberShipBanner.tag_text}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'membershippopupbanner',
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    bannerPlaceHolderForMemberShipBanner: {
      type: Object,
      required: true,
      default: () => ({}) // Default to an empty object
    }
  },
  data () {
    return {
      perks: [
        { icon: 'https://tss-static-images.gumlet.io/bannerrupee.png', title: 'Big Discounts' },
        { icon: 'https://tss-static-images.gumlet.io/giftbox.png', title: 'Early Access' },
        { icon: 'https://tss-static-images.gumlet.io/bannerlock.png', title: 'Birthday Discount' },
        { icon: 'https://tss-static-images.gumlet.io/freemembership.png', title: 'Free Shipping' }
      ],
      closing: false,
      exclusiveAdded: false
    }
  },
  computed: {
    ...mapGetters(['_cart', 'site_config', 'isSelectedCountryIndia', 'isExclusive', 'exclusiveUser']),
    EXCLUSIVE_PRODUCTS: function () {
      return this.site_config.exclusive_products.map(item => item['prod_id'])
    },
    EXCLUSIVE_PRODUCTS_UPGRADE: function () {
      return this.site_config.exclusive_products_upgrade.find(upgradeProduct => upgradeProduct.duration === 365)
    }
  },
  methods: {
    addMemToCartInitial (resCart, resEx) {
      if (this.isSelectedCountryIndia) {
        this.$store.dispatch('UPDATE_CART', {type: 'products', operation: 'set', name: 'Exclusive', data: {prod_id: resEx.product_id, quantity: 1, categories: []}, callercomp: 'PDP'}).then((res) => {
          this.exclusiveAdded = true
          this.$emit('exclusiveMembershipAdded', this.exclusiveAdded)
          this.$emit('close')
          // if (res && res.animate) {
          //   if (this.isExclusiveRenewal) {
          //     this.renewMemberShipActive = false
          //     this.isExcMemRenewalBarVisible = false
          //   } else {
          //     Vue.ls.set('popupShownOnce', true)
          //   }
          // }
        })
      }
    },
    closePopup () {
      this.closing = true
      setTimeout(() => {
        this.$emit('close')
        this.closing = false
      }, 300) // Delay matches animation duration
    },
    purchaseMembership () {
      if (!this.isExclusive && !this.exclusiveUser) {
        this.$store.dispatch('GET_EXC_MEM_DATA_FROM_CMS').then((resEx) => {
          // only show this popUp to exclusive user and only when they add upgrade membership product into cart
          if (resEx && Object.keys(resEx)) {
            if (parseInt(resEx.product_id) === parseInt(this.EXCLUSIVE_PRODUCTS[2])) {
              this.addMemToCartInitial(this._cart, resEx)
            } else if (parseInt(resEx.product_id) === parseInt(this.EXCLUSIVE_PRODUCTS[3])) {
              this.addMemToCartInitial(this._cart, resEx)
            }
          }
        })
      }
      // this.addMemToCartInitial(this._cart, {product_id: this.EXCLUSIVE_PRODUCTS[2].prod_id})
      // this.closePopup()
    }
  }
}
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000000CC;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  z-index: 99999;
}

.popup-content {
  background: #000000;
  position: relative;
  background: url('https://tss-static-images.gumlet.io/pdpbanneroverlay.png');
  border-radius: 12px;
  width: 100%;
  padding: 20px;
  text-align: center;
  animation: slideUp 0.3s ease-out;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
}

.popup-content.slide-down {
  animation: slideDown 0.3s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideDown {
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(100%);
    opacity: 0;
  }
}
.popup-header {
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-pack: justify;
  /* justify-content: space-between; */
  -ms-flex-align: center;
  /* align-items: normal; */
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
}
hr.new2 {
  border: none; /* Remove the default border */
height: 2px; /* Set height for the gradient effect */
background-image: 
  linear-gradient(90deg, #E8A5FF 0%, #9F94E5 26.24%, #86C2F9 51.78%, #DFBCF9 75.5%, #FFA8E7 100%),
  repeating-linear-gradient(90deg, transparent, transparent 10px, #000 10px, #000 12px); /* Linear gradient and dashed pattern */
background-position: 0 0, 0 0;
background-repeat: no-repeat, repeat-x;
background-size: 100% 100%, 20px 100%;
}
  .close-btn {
      text-align: end;
      margin-bottom: 2px;
  }
.close-btn button{
  background: none;
  border: none;
  text-align: end;
  font-size: 14px;
  width: 9px;
  /* height: 9px; */
  outline: none;
  cursor: pointer;
  color: white;
}
.containerdashed {
  display: inline-block;
  width: 120%;
  position: relative;
  margin: 10px;
  left: -30px;
  border-top: 3px dashed #000;
  background: linear-gradient(#000 0 0), linear-gradient(90deg, #4fc3f7, #ab5ca4 49%, #ff512f) border-box;
}

.popup-area{
  background-color: #000000;
  border-top-left-radius: 24px;
  overflow: hidden;
  border-top-right-radius: 24px;
}
.popup-body {
  display: flex;
  -ms-flex-pack: distribute;
  justify-content: space-between;
  margin-bottom: 15px;
  flex-wrap: wrap;
}
.header-info{
  font-family: Open Sans;
font-size: 16px;
font-weight: 600;
line-height: 21.79px;
text-align: left;
align-self: center;
text-underline-position: from-font;
text-decoration-skip-ink: none;
background: linear-gradient(90deg, #E8A5FF 0%, #9F94E5 26.24%, #86C2F9 51.78%, #DFBCF9 75.5%, #FFA8E7 100%);
-webkit-background-clip: text;
text-transform: uppercase; /* Capitalizes the text */
color: transparent;
}
.perk {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 42%;
  font-size: 14px;
  margin-bottom: 20px;
}
.perk p {
  color: white;
  font-family: Poppins;
  font-size: 10px;
  font-weight: 600;
  line-height: 15px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  text-transform: uppercase;
}
.perk img {
  width: 45%;
  /* height: 56px; */
  margin-right: 12px;
  margin-bottom: 8px;
}

.membership-btn {
  background: linear-gradient(90deg, #F4E9FD, #D8C0E9, #D6F1FE, #F2F1FE, #D9C1EA, #F8DEF4);
  color: #000;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  text-transform: uppercase;
  font-family: 'Montserrat Alternates', sans-serif;
  font-size: 14px;
  cursor: pointer;
  width: 100%;
  font-weight: 800;
  line-height: 17.15px;
  letter-spacing: 0.5px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
</style>



// WEBPACK FOOTER //
// membershipPopUpBanner.vue?55853e04